import Button from "./Button";

/**
 * Button used for the survey.
 *
 * @note This button needs to use the theme from the database, which is structured
 * differently than the theme define in `src/theme.js`.
 * @param {object} props
 * @param {"xs" | "sm" | "md" | "lg" | "xl" | "2xl" | { fontSize: string; paddingX: string; paddingY: string }} props.size The size of the button. Defaults to `sm`.
 * @param {{ buttonBackgroundColor: string; buttonTextColor: string; }} props.colorTheme The theme for the button.
 * The default value is `{ buttonBackgroundColor: "#F0F3F9", buttonTextColor: "#455468" }` which is a white colored button.
 * @param {boolean} props.loading `true` to display a loader instead of the button content.
 * @param {boolean} props.disabled `true` to disable the button. Defaults to `false`.
 * @param {string} props.href Link for the button. An `<a>` tag is rendered instead of a `<button>` tag when this prop is provided.
 * @param {React.MouseEventHandler<HTMLButtonElement> | undefined} props.handleOnClick Handler for the button click event.
 * @param {React.ReactNode} props.children Content for the button.
 */
function SurveyButton({
    size = "sm",
    colorTheme = {
        buttonBackgroundColor: "#F0F3F9",
        buttonTextColor: "#455468",
    },
    loading = false,
    disabled = false,
    href,
    handleOnClick,
    children,
    ...props
}) {
    return (
        <Button
            handleOnClick={handleOnClick}
            size={size}
            colorTheme={colorTheme}
            loading={loading}
            disabled={disabled}
            href={href}
            {...props}
        >
            <b>{children}</b>
        </Button>
    );
}

export default SurveyButton;
